import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UserUnion } from '@airgram/web';
import { TelegramMessengerService } from '@src/app/modules/telegram';
import { ChatModel, UserUI } from '@src/models';
import { UserService } from '@src/core/services';

@Component({
  selector: 'telegram-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserComponent implements OnChanges {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly userService = inject(UserService);
  private readonly messengerService = inject(TelegramMessengerService);

  @Input() userTelegram?: UserUnion;
  @Input() chat?: ChatModel;
  userUnions?: UserUI;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userTelegram && this.userTelegram) {
      lastValueFrom(this.userService.getUsersData([this.userTelegram.id])).then(userProfiles => {
        this.userUnions = userProfiles[0];
        this.cdr.markForCheck();
      });
    }

    this.cdr.markForCheck();
  }

  onChangeNotificationsToggleValue() {
    if (this.chat?.id) {
      this.messengerService.api
        .setChatNotificationSettings(this.chat.id, this.chat.notificationSettings.muteFor !== 0)
        .then(() => this.cdr.markForCheck());
    }
  }
}
